import {
  Row,
  Col,
  Card,
  Radio,
  Button,
  Typography,
  Popconfirm,
  Form,
  Input,
  Modal,
} from "antd";

import { useEffect, useState } from "react";
import {
  addCategoryAPI,
  deleteCategoryAPI,
  editCategoryAPI,
  getSubCategoriesAPI,
} from "../api/category";
import constant from "../config/constant";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
const { Title } = Typography;

function SubCategory() {
  const [form] = Form.useForm();
  const [categories, setCategories] = useState([]);
  const [parent_category, setParentCategory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryForUpdate, setCategoryForUpdate] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    setParentCategory(window.history.state?.usr?.category_id);
    _getSubCategories(window.history.state?.usr?.category_id);
  }, [window.history.state?.usr?.category_id]);

  const _getSubCategories = async (id) => {
    const data = {
      parent_category_id: id,
    };
    const res = await getSubCategoriesAPI(data);
    if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
      setCategories(res?.data);
    }
    console.log(res);
  };
  const onChange = (e) => console.log(`radio checked:${e.target.value}`);
  const _goBack = () => {
    navigate(-1);
  };
  const _addSubCategory = async (values) => {
    try {
      let res;
      if (categoryForUpdate) {
        res = await editCategoryAPI(categoryForUpdate, {
          category_name: values?.category_name,
        });
      } else {
        res = await addCategoryAPI({
          category_name: values?.category_name,
          parent_category_id: parent_category,
        });
      }

      if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
        _getSubCategories(parent_category);
        setIsModalOpen(false);
        setCategoryForUpdate(null);
      }
    } catch (e) {
      console.log("Error", e);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const _editCategory = (d) => {
    form.setFieldsValue({
      category_name: d?.category_name,
    });
    setCategoryForUpdate(d?.id);
    setIsModalOpen(true);
  };
  const _deleteSubCategory = async (id) => {
    const res = await deleteCategoryAPI(id);
    if (res.statusCode === constant.RESPONSE_CODE.SUCCESS) {
      _getSubCategories(parent_category);
    }
  };
  return (
    <>
      <div className="tabled">
        <div
          style={{ paddingTop: 10, paddingBottom: 10, cursor: "pointer" }}
          onClick={_goBack}
        >
          <ArrowLeftOutlined /> Back
        </div>

        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Sub Categories"
              extra={
                <>
                  <Radio.Group onChange={onChange} defaultValue="a">
                    <Radio.Button value="a" onClick={showModal}>
                      <PlusOutlined />
                      <span style={{ marginLeft: 10 }}>
                        Add New SubCategory
                      </span>
                    </Radio.Button>
                  </Radio.Group>
                </>
              }
            >
              <div className="ant-list-box table-responsive m-25">
                <table className="width-100">
                  <thead>
                    <tr>
                      <th>
                        <div className="text-center">ID</div>
                      </th>
                      <th>
                        <div className="text-center">SubCategory Name</div>
                      </th>
                      <th>
                        <div className="text-center">Action</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((d, index) => (
                      <tr key={index}>
                        <td>
                          <div className="text-xs text-center">{d?.id}</div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            <Title level={5}>{d?.category_name}</Title>
                          </div>
                        </td>

                        <td>
                          <div
                            className="col-action text-right"
                            style={{ justifyContent: "center" }}
                          >
                            <Button
                              type="dashed"
                              className="darkbtn"
                              onClick={() => _editCategory(d)}
                            >
                              <EditOutlined style={{ fontSize: "16px" }} />
                              Edit
                            </Button>
                            <Popconfirm
                              title="Delete this user? "
                              description="Are you sure to delete this user?"
                              okText="Yes"
                              cancelText="No"
                              onConfirm={() => _deleteSubCategory(d?.id)}
                            >
                              <Button type="dashed" style={{ marginLeft: 10 }}>
                                <DeleteOutlined
                                  className="text-danger"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                />
                                <span className="text-danger">Delete</span>
                              </Button>
                            </Popconfirm>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        title="Add Category"
        open={isModalOpen}
        okCancel={false}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          name="basic"
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={_addSubCategory}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label="Sub Category Name"
            name="category_name"
            rules={[
              {
                required: true,
                message: "Please enter subcategory name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 20,
              span: 4,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default SubCategory;
